import { ShiftModalComponentMap } from 'modals/ShiftModal/ShiftModal.constants';
import {
  shiftModalRoutingService,
  useShiftModalUIContext,
} from 'modals/ShiftModal/ShiftModal.ui.context';
import { AuditTrailTabView } from 'modals/ShiftModal/src/views/AuditTrailView/AuditTrailTabView';
import { NotifyTeamMember } from 'modals/ShiftModal/src/views/NotifyTeamMember';
import { useURLParameters } from 'hooks';
import { FC, useEffect } from 'react';
import { withMemo } from 'utils/withMemo';

export const AuditTrailView: FC = () => {
  const [{ calloutListId }, { removeParam }] = useURLParameters<{ calloutListId: string }>();
  useEffect(
    () => () => {
      if (calloutListId) {
        removeParam('calloutListId');
        shiftModalRoutingService.goToPrevView();
      }
    },
    [calloutListId, removeParam],
  );
  return <AuditTrailTabView />;
};

export const AuditTrailViewRenderer: FC = withMemo((props) => {
  const { shiftModalActiveModalView } = useShiftModalUIContext();
  const Component = {
    ...ShiftModalComponentMap,
    AuditTrailView,
    NotifyTeamMember,
  }[shiftModalActiveModalView];
  return <Component {...props} />;
});
